import React from "react";
import { Fuel } from "lucide-react";
import { FUEL_UNITS } from "@/lib/newTripConstants";

// Fuel Order (pilot only, origin = base airport).
// Visibility gating is done by the parent.
export default function FuelOrderSection({
  leg,
  legIndex,
  userFuelUnit,
  setUserFuelUnit,
  updateLeg,
  t,
}) {
  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-3 space-y-3">
      <div className="flex items-center gap-2">
        <Fuel className="w-4 h-4 text-amber-400" />
        <span className="text-xs font-semibold text-amber-400 uppercase tracking-wide">
          {t("newTrip.fuelOrderTitle")}
        </span>
        {leg.fuel_order && (
          <button
            type="button"
            onClick={() => updateLeg(legIndex, "fuel_order", null)}
            className="ml-auto text-[10px] text-slate-400 hover:text-red-400 transition-colors"
          >
            {t("newTrip.deleteFuelOrder")}
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-[10px] text-slate-400 mb-1 block">
            {t("newTrip.fuelTypeLabel")}
          </label>
          <input
            type="text"
            value={leg.fuel_order?.type || ""}
            onChange={(e) =>
              updateLeg(legIndex, "fuel_order", {
                ...(leg.fuel_order || {}),
                type: e.target.value,
                fuel_unit: userFuelUnit,
              })
            }
            placeholder={t("common.fuelMethodPlaceholder")}
            className="w-full bg-[#0f172a] border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-amber-500/50 placeholder:text-slate-400"
          />
        </div>
        <div>
          <label className="text-[10px] text-slate-400 mb-1 block">
            {t("newTrip.quantityLabel")}
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              value={leg.fuel_order?.quantity || ""}
              onChange={(e) =>
                updateLeg(legIndex, "fuel_order", {
                  ...(leg.fuel_order || {}),
                  quantity: e.target.value,
                  fuel_unit: userFuelUnit,
                })
              }
              placeholder={t("newTrip.quantityHint")}
              className="flex-1 min-w-0 bg-[#0f172a] border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-amber-500/50"
            />
            <div
              className={`flex rounded-lg overflow-hidden border border-slate-700 flex-shrink-0 ${/[a-zA-Z]/.test(String(leg.fuel_order?.quantity || "")) ? "hidden" : ""}`}
            >
              {FUEL_UNITS.map((unit) => (
                <button
                  key={unit}
                  type="button"
                  onClick={() => {
                    setUserFuelUnit(unit);
                    updateLeg(legIndex, "fuel_order", {
                      ...(leg.fuel_order || {}),
                      fuel_unit: unit,
                    });
                  }}
                  className={`px-2 py-1 text-[10px] font-medium transition-colors ${
                    userFuelUnit === unit
                      ? "bg-amber-500/20 text-amber-400"
                      : "bg-[#0f172a] text-slate-500 hover:text-slate-300"
                  }`}
                >
                  {unit}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      {leg.fuel_order?.type && leg.fuel_order?.quantity && (
        <p className="text-[10px] text-amber-400/70">
          {t("newTrip.fuelOrderPrefix")}
          <span className="font-semibold text-amber-400">{leg.fuel_order.type}</span> —{" "}
          {leg.fuel_order.quantity}
          {!/[a-zA-Z]/.test(String(leg.fuel_order.quantity)) ? ` ${userFuelUnit}` : ""}
        </p>
      )}
    </div>
  );
}
